import React from 'react';
import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.55 } },
};

const Experience = () => (
  <section id="experience" className="section">
    <div className="section-inner">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-80px' }}
        variants={{ visible: { transition: { staggerChildren: 0.12 } } }}
      >
        <motion.p className="section-label" variants={fadeUp}>Career</motion.p>
        <motion.h2 className="section-title" variants={fadeUp}>Experience &amp; Education</motion.h2>

        <motion.div className="experience-grid" variants={fadeUp}>
          {/* Work Experience */}
          <div>
            <p className="experience-column-title">Work Experience</p>
            <div className="timeline">
              <div className="timeline-item">
                <p className="timeline-year">2023 – Present</p>
                <p className="timeline-title">
                  Software Engineer · <span>DronaHQ</span>
                </p>
                <div className="timeline-desc">
                  <p><b><a href="https://dronahq.com/vibe-coding" target="_blank" rel="noopener noreferrer">Vibe Coding</a>:</b> Built an AI feature that converts natural language prompts into production-ready React.js apps (UI + business logic), slashing manual development time and enabling faster app creation.</p>
                  <br />
                  <p><b><a href="https://dronahq.ai/" target="_blank" rel="noopener noreferrer">Veda AI</a>:</b> Designed using NLP, vision-based LLMs, and advanced prompt engineering to auto-generate full applications from user descriptions. Reduced configuration time by <b>80%</b>.</p>
                  <br />
                  <p><b><a href="https://dronahq.com/form-builder" target="_blank" rel="noopener noreferrer">Form Builder</a>:</b> Real-time, database-agnostic form builder (MongoDB, PostgreSQL, MySQL). Improved development speed by <b>75%</b>.</p>
                  <br />
                  <p><b>Audit Logging:</b> Engineered robust event logging — key differentiator for premium tier, contributed to <b>30% increase</b> in premium subscriptions.</p>
                  <br />
                  <p><b>Recognition:</b> Awarded <b>"Star Performer of the Year"</b>.</p>
                </div>
              </div>
              <div className="timeline-item">
                <p className="timeline-year">2023</p>
                <p className="timeline-title">
                  Software Engineer Intern · <span>DronaHQ</span>
                </p>
                <div className="timeline-desc">
                  Revamped core web pages, boosting conversion rates by <b>25%</b> and reducing bounce rates by <b>40%</b>. Enhanced builder performance with an <b>80%</b> improvement in loading speed.
                </div>
              </div>
            </div>
          </div>

          {/* Education */}
          <div>
            <p className="experience-column-title">Education</p>
            <div className="timeline">
              <div className="timeline-item">
                <p className="timeline-year">2021 – 2023</p>
                <p className="timeline-title">
                  Master of Computer Application · <span>MET Institute of Computer Science, Mumbai</span>
                </p>
                <div className="timeline-desc">CGPA: 9.01</div>
              </div>
              <div className="timeline-item">
                <p className="timeline-year">2018 – 2021</p>
                <p className="timeline-title">
                  BSc Computer Science · <span>Rizvi College of Arts Science and Commerce</span>
                </p>
                <div className="timeline-desc">CGPA: 9.08</div>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div>
            <p className="experience-column-title">Certifications</p>
            <div className="timeline">
              <div className="timeline-item">
                <p className="timeline-year">AWS</p>
                <p className="timeline-title">
                  <a href="https://www.credly.com/go/3nUE7k08" target="_blank" rel="noopener noreferrer">
                    Academy Data Analytics
                  </a>
                </p>
                <div className="timeline-desc">Amazon Web Services</div>
              </div>
              <div className="timeline-item">
                <p className="timeline-year">Oracle</p>
                <p className="timeline-title">
                  <a href="https://bit.ly/3HqFNP6" target="_blank" rel="noopener noreferrer">
                    Java Programming
                  </a>
                </p>
                <div className="timeline-desc">Oracle Academy</div>
              </div>
              <div className="timeline-item">
                <p className="timeline-year">Coursera</p>
                <p className="timeline-title">
                  <a href="https://www.coursera.org/verify/8UAF2J3HGQ3Z" target="_blank" rel="noopener noreferrer">
                    Python Data Structures
                  </a>
                </p>
                <div className="timeline-desc">University of Michigan</div>
              </div>
              <div className="timeline-item">
                <p className="timeline-year">Udemy</p>
                <p className="timeline-title">JavaScript Development</p>
                <div className="timeline-desc">Cert No. UC-1KWW97V9</div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </div>
  </section>
);

export default Experience;
